import React from "react";
import HomeSection from "../components/MainSection/HomeSection";
const Home = () => {
  return (
    <>
      <div>
        <HomeSection />
      </div>
    </>
  );
};

export default Home;
